const CART_TOKEN_KEY = 'cart_session_token_v2';

/** Capability for an unbound guest cart. The public session ID is never proof of ownership. */
export function getCartToken(): string | null {
  if (typeof localStorage === 'undefined') return null;
  const value = localStorage.getItem(CART_TOKEN_KEY);
  return value && /^[a-f0-9]{64}$/.test(value) ? value : null;
}

export function ensureCartToken(): string {
  const current = getCartToken();
  if (current) return current;
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const token = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  localStorage.setItem(CART_TOKEN_KEY, token);
  return token;
}

export function clearCartToken(): void {
  localStorage.removeItem(CART_TOKEN_KEY);
}

export function cartRequestHeaders(headers?: HeadersInit): Headers {
  const result = new Headers(headers);
  const token = getCartToken();
  if (token) result.set('x-cart-token', token);
  else result.delete('x-cart-token');
  return result;
}
